import { render } from "./ProductsSearchComponent.vue?vue&type=template&id=9082d186&ts=true"
import script from "./ProductsSearchComponent.vue?vue&type=script&lang=ts"
export * from "./ProductsSearchComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__